import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import SelectFieldCustom from '../ui/SelectFieldCustom';
import { TextFieldCustom } from '../ui/TextFieldCustom';
import DeleteIcon from '@material-ui/icons/Delete';
import SplitButton from '../ui/SplitButton';
import { useTranslation } from 'react-i18next';
import { AddressAutocomplete } from '../ui/AddressAutocomplete';

export const FormAssets = ({ indexApp, data }) => {
    const { control } = useFormContext();
    const { t } = useTranslation();
    const { fields: assetsFields, append: assetsAppend, remove: assetsRemove } = useFieldArray({
        control,
        name: `applicants[${indexApp}].assets`
    });
    const {
        fields: vehicledFields,
        append: vehiclesAppend,
        remove: vehiclesRemove
    } = useFieldArray({
        control,
        name: `applicants[${indexApp}].vehicles`
    });
    const {
        fields: propertyFields,
        append: propertyAppend,
        remove: propertyRemove
    } = useFieldArray({
        control,
        name: `applicants[${indexApp}].property`
    });

    const assettype = t('los:assettype', { returnObjects: true });
    const realestatetype = t('los:realestatetype', { returnObjects: true });

    return (
        <>
            <Typography component="div">
                <Box fontWeight="fontWeightMedium" pb={2} color="primary.main">
                    {indexApp === 0
                        ? t('employerLabels.titleAsset')
                        : t('employerLabels.titleAsset2')}
                </Box>
            </Typography>
            {assetsFields.map((asset, indexAss) => {
                return (
                    <Box key={asset.id}>
                        <Grid container spacing={3}>
                            <Grid item md={6} xs={12}>
                                <SelectFieldCustom
                                    name={`applicants[${indexApp}].assets[${indexAss}].type`}
                                    label={t('assetLabels.assetSource')}
                                    items={assettype}
                                    defaultValue={asset.type}
                                />
                            </Grid>
                            <Grid item md={5} xs={12}>
                                <TextFieldCustom
                                    name={`applicants[${indexApp}].assets[${indexAss}].value`}
                                    label={t('assetLabels.value')}
                                    money="true"
                                    defaultValue={asset.value}
                                />
                            </Grid>
                            {/* {indexAss > 0 ? ( */}
                            <Grid item md={1}>
                                <IconButton
                                    aria-label="delete"
                                    size="medium"
                                    onClick={() => {
                                        assetsRemove(indexAss);
                                    }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                            {/* ) : null} */}
                        </Grid>
                    </Box>
                );
            })}
            {/* <Button
            onClick={() => {
               assetsAppend({ type: '', value: '' });
            }}
            size="small"
         >
            {assetsFields.length === 0 ? 'Add asset' : 'Add another asset'}
         </Button> */}
            {vehicledFields.map((vehicle, indexVehicle) => {
                return (
                    <div key={vehicle.id}>
                        <Grid container spacing={3}>
                            <Grid item md={2} xs={3}>
                                <TextFieldCustom
                                    name={`applicants[${indexApp}].vehicles[${indexVehicle}].year`}
                                    label={t('assetLabels.vehicleYear')}
                                    type="number"
                                    defaultValue={vehicle.year}
                                />
                            </Grid>
                            <Grid item md={3} xs={3}>
                                <TextFieldCustom
                                    name={`applicants[${indexApp}].vehicles[${indexVehicle}].make`}
                                    label={t('assetLabels.vehicleMake')}
                                    defaultValue={vehicle.make}
                                />
                            </Grid>
                            <Grid item md={3} xs={3}>
                                <TextFieldCustom
                                    name={`applicants[${indexApp}].vehicles[${indexVehicle}].model`}
                                    label={t('assetLabels.vehicleModel')}
                                    defaultValue={vehicle.model}
                                />
                            </Grid>

                            <Grid item md={3} xs={3}>
                                <TextFieldCustom
                                    name={`applicants[${indexApp}].vehicles[${indexVehicle}].value`}
                                    label={t('assetLabels.vehicleValue')}
                                    money="true"
                                    defaultValue={vehicle.value}
                                />
                            </Grid>
                            {/* {indexVehicle > 0 ? ( */}
                            <Grid item md={1}>
                                <IconButton
                                    aria-label="delete"
                                    size="medium"
                                    onClick={() => {
                                        vehiclesRemove(indexVehicle);
                                    }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                            {/* ) : null} */}
                        </Grid>
                    </div>
                );
            })}
            {/* <Button
            onClick={() => {
               vehiclesAppend({ make: '', model: '', year: '', value: '' });
            }}
            size="small"
         >
            {assetsFields.length === 0 ? 'Add vehicle' : 'Add another vehicle'}
         </Button> */}
            {propertyFields.map((property, indexprop) => {
                return (
                    <div key={property.id}>
                        <Grid container spacing={3}>
                            <Grid item md={6} xs={12}>
                                <AddressAutocomplete
                                    name={`applicants[${indexApp}].property[${indexprop}].longAddress`}
                                    label={t('assetLabels.propertyAddress')}
                                    defaultValue={property.longAddress}
                                />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <SelectFieldCustom
                                    name={`applicants[${indexApp}].property[${indexprop}].type`}
                                    label={t('assetLabels.propertyType')}
                                    items={realestatetype}
                                    defaultValue={property.type}
                                />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                <TextFieldCustom
                                    name={`applicants[${indexApp}].property[${indexprop}].value`}
                                    label={t('assetLabels.propertyValue')}
                                    money="true"
                                    defaultValue={property.value}
                                />
                            </Grid>
                            {/* {indexprop > 0 ? ( */}
                            <Grid item md={1}>
                                <IconButton
                                    aria-label="delete"
                                    size="medium"
                                    onClick={() => {
                                        propertyRemove(indexprop);
                                    }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                            {/* ) : null} */}
                        </Grid>
                    </div>
                );
            })}
            {/* <Button
            onClick={() => {
               propertyAppend({ address: '', value: '' });
            }}
            size="small"
         >
            {propertyFields.length === 0 ? 'Add property' : 'Add another property'}
         </Button> */}
            <br />
            <SplitButton
                onClick={(btnType) => {
                    if (btnType === 0) assetsAppend({ type: '', value: '' });
                    if (btnType === 1) vehiclesAppend({ make: '', model: '', year: '', value: '' });
                    if (btnType === 2)
                        propertyAppend({
                            longAddress: '',
                            address: { location: '', city: '', postalCode: '', province: '' },
                            value: ''
                        });
                }}
            />
        </>
    );
};
